/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Lpvisibility_Savesuccess3Inputs */

const en_coinvestments_insights_lpvisibility_savesuccess3 = /** @type {(inputs: Coinvestments_Insights_Lpvisibility_Savesuccess3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibility updated`)
};

/**
* | output |
* | --- |
* | "Visibility updated" |
*
* @param {Coinvestments_Insights_Lpvisibility_Savesuccess3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_lpvisibility_savesuccess3 = /** @type {((inputs?: Coinvestments_Insights_Lpvisibility_Savesuccess3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Lpvisibility_Savesuccess3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_lpvisibility_savesuccess3(inputs)
});
export { coinvestments_insights_lpvisibility_savesuccess3 as "coInvestments_insights_lpVisibility_saveSuccess" }